var map = {
	"./official-media-modal-layer-1.png": "br2t",
	"./official-media-modal-layer-2.png": "Es31",
	"./official-media-modal-layer-3.png": "PXGK",
	"./official-media-modal-layer-4.png": "kqIO",
	"./企业微信.png": "uURv",
	"./官方微博.png": "61ac",
	"./官方抖音.png": "fCPi",
	"./微信公众号.png": "ILT6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m7Zh";